module.exports = __webpack_public_path__ + "img/acc9.a163aef3.png";